import { Component, EventEmitter, OnInit, Output , ChangeDetectorRef } from '@angular/core';
import { WizardStateService } from '../../../services/wizard-state.service';
import { take } from 'rxjs/operators';
import {
  PROVINCE_CHAOS_LEVELS,
  PROVINCE_STABILITIES,
  PROVINCE_PROSPERITIES
} from '../../../constants/province.constants';

interface ProvinceEntry {
  azgaarId?: number;
  name: string;
  stability: string;
  prosperity: string;
  notes: string;
}

@Component({
    selector: 'app-provinces-step',
    templateUrl: './provinces-step.component.html',
    styleUrls: ['./provinces-step.component.scss'],
    standalone: false
})
export class ProvincesStepComponent implements OnInit {
  @Output() next = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  chaosLevels = PROVINCE_CHAOS_LEVELS;
  stabilities = PROVINCE_STABILITIES;
  prosperities = PROVINCE_PROSPERITIES;

  mapName = '';
  provinceChaosLevel = '';
  provincesList: ProvinceEntry[] = [];

  constructor(private stateService: WizardStateService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.stateService.state.pipe(take(1)).subscribe(state => {
      this.mapName = state.mapName || 'World';
      this.provinceChaosLevel = state.provinceChaosLevel || '';

      // Initialize provinces from state, mapping prefilled data
      if (state.provinces && state.provinces.length > 0) {
        this.provincesList = state.provinces.map((p: any) => ({
          azgaarId: p.azgaarId || p.azgaar_id,
          name: p.name,
          stability: p.stability || '',
          prosperity: p.prosperity || '',
          notes: p.notes || ''
        }));
      } else {
        let extractedProvinces: ProvinceEntry[] = [];
        if (state.mapJson) {
          const json = state.mapJson;
          const rawProvinces = json.provinces || json.pack?.provinces || [];
          extractedProvinces = rawProvinces
            .filter((p: any) => p && p.name && p.name !== 'none' && p.name.toLowerCase() !== 'neutral' && p.name !== 'Wild')
            .map((p: any) => ({
              azgaarId: p.i,
              name: p.name,
              stability: '',
              prosperity: '',
              notes: ''
            }));
        }

        if (extractedProvinces.length > 0) {
          this.provincesList = extractedProvinces;
        } else {
          this.provincesList = [
            { azgaarId: 1, name: 'Province1', stability: '', prosperity: '', notes: '' },
            { azgaarId: 2, name: 'Province2', stability: '', prosperity: '', notes: '' },
            { azgaarId: 3, name: 'Province3', stability: '', prosperity: '', notes: '' }
          ];
        }
      }
      this.cdr.detectChanges();
    });
  }

  saveState(): void {
    this.stateService.updateState({
      provinceChaosLevel: this.provinceChaosLevel,
      provinces: this.provincesList
    });
  }

  onNext(): void {
    this.saveState();
    this.next.emit();
  }

  onBack(): void {
    this.saveState();
    this.back.emit();
  }
}
